import { computed, inject, ref, watch } from 'vue';
import { IKApplicationPersistentData } from '@/services/persistentDataProvider/persistentDataProvider.types';
import { CommonPersistentDataSection, CommonPersistentDataType, IKCommonPersistentData } from '@/components/common/services/commonDataService.types';
import { app } from '@/bootloader';

export const useCommonPersistentDataProvider = () => {
  const appPersistentData = inject(IKApplicationPersistentData);
  const commonPersistentData = ref<CommonPersistentDataType>({
    notifications: {
      lastNotificationIndexSeen: 0,
    },
    defaultPasswordNotifyClosed: false,
  });

  watch(
    () => appPersistentData?.GQL?.networkStatus?.value,
    () => {
      const result = appPersistentData?.getPersistentData(CommonPersistentDataSection) as CommonPersistentDataType;
      if (result && typeof result === 'object' && Object.keys(result).length > 0) {
        commonPersistentData.value = result;
      }
    },
    {
      immediate: true,
    },
  );

  const getNotificationsLastNotificationIndexSeen = computed(() => commonPersistentData.value?.notifications?.lastNotificationIndexSeen);
  const setNotificationsLastNotificationIndexSeen = (value: number) => {
    commonPersistentData.value.notifications.lastNotificationIndexSeen = value;
    appPersistentData?.setPersistentData(CommonPersistentDataSection, commonPersistentData.value);
  };

  const getDefaultPasswordNotifyClosed = computed(() => commonPersistentData.value?.defaultPasswordNotifyClosed);
  const setDefaultPasswordNotifyClosed = (value: boolean) => {
    commonPersistentData.value.defaultPasswordNotifyClosed = value;
    appPersistentData?.setPersistentData(CommonPersistentDataSection, commonPersistentData.value);
  };

  const payload = {
    getNotificationsLastNotificationIndexSeen,
    setNotificationsLastNotificationIndexSeen,
    getDefaultPasswordNotifyClosed,
    setDefaultPasswordNotifyClosed,
  };

  app.provide(IKCommonPersistentData, payload);
  return payload;
};
